import { render, staticRenderFns } from "./QServRedirectComp.vue?vue&type=template&id=6fd48074&"
import script from "./QServRedirectComp.vue?vue&type=script&lang=js&"
export * from "./QServRedirectComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports